import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './ui/theme'
import { applyDark, getStoredDark } from './ui/darkMode'
import './index.css'

// Aplica o tema (claro/escuro) salvo antes de renderizar, evitando flash.
applyDark(getStoredDark())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
